// 兼容 sapper
import {writable} from 'svelte/store';
import {url$} from '@px/streams/url';

const page = writable({path: '', query: {}});

const _history =
  typeof history !== 'undefined'
    ? history
    : {
        pushState(data: any, unused: string, url?: string | URL | null) {},
        replaceState(data: any, unused: string, url?: string | URL | null) {},
      };

url$.subscribe((url) => page.set({path: url.pathname, query: url.query}));

export function stores() {
  return {page};
}

export function goto(target: string, opts: {replaceState: boolean}) {
  const {replaceState = false} = opts || {};
  const url = selectTarget(new URL(target, document.baseURI));
  if (url) {
    if (replaceState) {
      _history.replaceState({}, '', url);
      return;
    }
    _history.pushState({}, '', url);
    return;
  }
  window.location.href = target;
  return new Promise(() => {});
}

function selectTarget(url) {
  if (url.origin !== location.origin || url.pathname !== location.pathname) {
    return null;
  }
  return url;
}
